import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface NotificationRecipient {
  userId?: number;
  userSubjectId?: string;
  userName?: string;
  email?: string;
  defaultFieldName?: string;
  recipient1Name?: string;
  recipient1Contact?: string;
  recipient2Name?: string;
  recipient2Contact?: string;
}

export interface CreateNotificationConfig {
  logSheetTemplateId: number;
  notificationChannels: string;
  notificationType: string;
  recipientType: string;
  csvFileName?: string;
  recipients: NotificationRecipient[];
}

export interface UpdateNotificationConfig {
  notificationConfigId: number;
  notificationChannels: string;
  notificationType: string;
  recipientType: string;
  csvFileName?: string;
  recipients: NotificationRecipient[];
}

export type CreateNotificationConfigBatch = CreateNotificationConfig[];

export interface NotificationConfigResponse {
  notificationConfigId: number;
  logSheetTemplateId: number;
  logSheetTemplateName: string;
  notificationChannels: string;
  notificationType: string;
  recipientType: string;
  csvFileName?: string;
  dateCreated: Date;
  lastModifiedDate: Date;
  isActive: boolean;
  recipients: NotificationRecipient[];
}

@Injectable({
  providedIn: 'root'
})
export class NotificationConfigService {
  private baseUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getByLogSheetTemplateId(logSheetTemplateId: number): Observable<NotificationConfigResponse> {
    return this.http.get<NotificationConfigResponse>(
      `${this.baseUrl}/NotificationConfig/logsheet/${logSheetTemplateId}`
    );
  }

  getByLogSheetTemplateIdBatch(logSheetTemplateId: number): Observable<NotificationConfigResponse[]> {
    return this.http.get<NotificationConfigResponse[]>(
      `${this.baseUrl}/NotificationConfig/logsheet/${logSheetTemplateId}/all`
    );
  }

  getById(id: number): Observable<NotificationConfigResponse> {
    return this.http.get<NotificationConfigResponse>(
      `${this.baseUrl}/NotificationConfig/${id}`
    );
  }

  getAll(): Observable<NotificationConfigResponse[]> {
    return this.http.get<NotificationConfigResponse[]>(
      `${this.baseUrl}/NotificationConfig`
    );
  }

  create(config: CreateNotificationConfigBatch): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/NotificationConfig`,
      config
    );
  }

  update(id: number, config: UpdateNotificationConfig): Observable<any> {
    return this.http.patch<any>(
      `${this.baseUrl}/NotificationConfig/${id}`,
      config
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.baseUrl}/NotificationConfig/${id}`
    );
  }
}
